/**
 * @generated SignedSource<<bafb70ada49c8f9bd5e4b937d48dbc1a>>
 * @relayHash 0b2505d11363999cce7d3f65d08d042c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c066116a335db97517b00d811cc837aaaf601a82bc08ed9e658aa2611f27ec0a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevAiFlowSessionsStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PAUSED" | "PENDING" | "%future added value";
export type flowsQuery$variables = {
  cloudId: string;
  creator: string;
};
export type flowsQuery$data = {
  readonly devai_flowSessionsByCreatorAndCloudId: ReadonlyArray<{
    readonly additionalInfoJSON: string | null | undefined;
    readonly id: string;
    readonly sessionARI: string;
    readonly status: DevAiFlowSessionsStatus | null | undefined;
  } | null | undefined> | null | undefined;
};
export type flowsQuery = {
  response: flowsQuery$data;
  variables: flowsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creator"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "creator",
        "variableName": "creator"
      }
    ],
    "concreteType": "DevAiFlowSession",
    "kind": "LinkedField",
    "name": "devai_flowSessionsByCreatorAndCloudId",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "sessionARI"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      },
      {
        "kind": "ScalarField",
        "name": "additionalInfoJSON"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "flowsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "flowsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "c066116a335db97517b00d811cc837aaaf601a82bc08ed9e658aa2611f27ec0a",
    "metadata": {},
    "name": "flowsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5a338790b3796f41b3009f0dcc3c934f";

export default node;
